import { Link } from "react-router-dom";

const BreadcrumbsComponent = (props: any) => {
  return (
    <div key={Math.random()} id="breadcrumbs">
      {props.items.map((item: any, i: number) => (
        <span key={item.path + "span"}>
          <Link key={item.path + "link"} to={item.path}>
            {item.label}
          </Link>{" "}
          {i + 1 < props.items.length ? (
            <i key={item.path + "i"} className="fa fa-chevron-right" />
          ) : (
            ""
          )}
        </span>
      ))}
    </div>
  );
};

export default BreadcrumbsComponent;
